export { default } from './ReduxModal';


// WEBPACK FOOTER //
// ./src/components/reduxModal/index.js